import React from "react";
import {CartList} from "@/components/Shop/CartList/CartList";

export const CartPage = () => {

    return <CartList />

};
